declare global {
    interface Performance {
        memory?: {
            usedJSHeapSize: number;
        }
    }
}
/**
 * 获取内存大小，单位M
 */
export function getMemory() {
    let usedJSHeapSize = 0;
    if (window.performance?.memory) {
        ({ usedJSHeapSize } = window.performance.memory);
        usedJSHeapSize = Math.round(usedJSHeapSize / 1024 / 1024); // 转为M
    }
    return usedJSHeapSize;
}
